(() => {
  const category = new URLSearchParams(window.location.search).get('blog-category');
  const nextLink = document.querySelector('[data-filtered-next-work]');

  if (!nextLink) return;
  if (!category) return; // No filter applied, use default next article from template

  const currentPath = window.location.pathname.replace(/\/$/, '');
  const filteredBlogUrl = new URL(`${nextLink.dataset.blogUrl}/tagged/${encodeURIComponent(category)}`, window.location.origin);

  const articlePath = (href) => new URL(href, window.location.origin).pathname.replace(/\/$/, '');
  const addCategory = (href) => {
    const url = new URL(href, window.location.origin);
    url.searchParams.set('blog-category', category);
    return `${url.pathname}${url.search}${url.hash}`;
  };

  const findNextWork = async () => {
    let pageUrl = filteredBlogUrl;
    let firstWorkUrl = null;
    const visitedUrls = new Set();

    while (!visitedUrls.has(pageUrl.href)) {
      visitedUrls.add(pageUrl.href);

      const response = await fetch(pageUrl.href);
      if (!response.ok) throw new Error(`Filtered blog request failed: ${response.status}`);

      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const works = [...document.querySelectorAll('.blog-articles__article')];
      if (!firstWorkUrl && works[0]) firstWorkUrl = works[0].href;

      const currentIndex = works.findIndex((work) => articlePath(work.href) === currentPath);
      if (currentIndex !== -1) {
        if (works[currentIndex + 1]) return works[currentIndex + 1].href;

        const nextPage = document.querySelector('.pagination__item--prev');
        if (nextPage?.href) {
          const nextPageResponse = await fetch(nextPage.href);
          if (!nextPageResponse.ok) throw new Error(`Filtered blog request failed: ${nextPageResponse.status}`);

          const nextPageDocument = new DOMParser().parseFromString(await nextPageResponse.text(), 'text/html');
          return nextPageDocument.querySelector('.blog-articles__article')?.href || firstWorkUrl;
        }

        return firstWorkUrl;
      }

      const nextPage = document.querySelector('.pagination__item--prev');
      if (!nextPage?.href) break;
      pageUrl = new URL(nextPage.href, window.location.origin);
    }

    return null;
  };

  findNextWork()
    .then((nextWorkUrl) => {
      if (nextWorkUrl) nextLink.href = addCategory(nextWorkUrl);
    })
    .catch(() => {
      // Keep the standard blog navigation if the filtered list cannot be loaded.
    });
})();
